// Standard library imports
import React, { useState, useEffect } from 'react';

// Internal module imports
import TabsComponent from '../../../../components/Tabs/Tabs';
import { NumberParam } from 'use-query-params';
import { useLoader, useQueryParamWithDefault } from '../../../../hooks';
import EdgeIncidents from './EdgeIncidents';
import { AdminService } from '../../../../services/AdminService';
import { toast } from 'react-toastify';

const Incidents = ({ cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('tab', NumberParam, 0, cId);

    const [startLoader, stopLoader] = useLoader();

    const [admins, setAdmins] = useState([]);

    useEffect(() => {
        getAdmins();
    }, []);

    const getAdmins = () => {
        AdminService.ReadAll(startLoader, handleAdminSuccess, handleError, stopLoader);
    };

    const handleAdminSuccess = ({ data }) => {
        let temp = [
            {
                label: 'All',
                value: 'all',
            },
        ];
        data.data.map((e) => {
            temp.push({ label: e.name, value: e._id });
        });
        setAdmins(temp);
    };

    const handleError = (err) => {
        let data = err && err.response ? err.response.data : null;
        if (data) toast.error(data.message);
        else toast.error('Internal server error!');
    };

    const tabs = [
        {
            name: 'Edge Incidents',
            component: <EdgeIncidents admins={admins} />,
            tabId: 1,
        },
    ];

    return (
        <div className={'ventilation'}>
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

export default Incidents;
